import React from "react";
import { I18n } from "@aws-amplify/core";
import update from "immutability-helper";
import { get, map } from "lodash";

import Grid from "@material-ui/core/Grid";

import FormSection from "../../Common/FormSection";
import CustomButton from "../../Common/CustomButton";
import DatePicker from "../../Common/DatePicker";
import { nowWithOutSeconds } from "../../../utils/date";

const availablePeriods = [
  {
    name: "today",
    daysNumber: "0",
  },
  {
    name: "yesterday",
    daysNumber: 1,
  },
  {
    name: "last2days",
    daysNumber: 2,
  },
  {
    name: "last7days",
    daysNumber: 7,
  },
  {
    name: "custom",
    daysNumber: "custom",
  },
];

const MdcForm = (props) => {
  const { search } = props;
  const [filters, setFilters] = React.useState({});

  // Set initial filters
  React.useEffect(() => {
    const now = new Date();
    const midnight = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      0,
      0,
      0
    );
    setFilters(
      update(filters, {
        dateFilter: { $set: "0" },
        startDate: { $set: midnight.getTime() },
        endDate: { $set: midnight.getTime() + 86400000 },
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (id, index, value) => {
    if (id === "period") {
      if (value === "custom") {
        setFilters(
          update(filters, {
            dateFilter: { $set: "custom" },
            startDate: { $set: nowWithOutSeconds() - 86400000 },
            endDate: { $set: nowWithOutSeconds() },
          })
        );
      } else {
        const now = new Date();
        const midnight = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          0,
          0,
          0
        );
        const startDate =
          value === "0"
            ? midnight.getTime()
            : new Date(midnight - 86400000 * value).getTime();
        const endDate =
          value === "0" ? midnight.getTime() + 86400000 : midnight.getTime();

        setFilters(
          update(filters, {
            dateFilter: { $set: value },
            startDate: { $set: startDate },
            endDate: { $set: endDate },
          })
        );
      }
    } else {
      setFilters(
        update(filters, {
          [id]: { $set: value },
        })
      );
    }
  };

  const handleChangeDate = (id, value) => {
    setFilters(
      update(filters, {
        [id]: { $set: new Date(value).getTime() },
      })
    );
  };

  return (
    <Grid container alignItems="center">
      <Grid item style={{ width: "200px", marginLeft: "12px" }}>
        <FormSection
          formValue={[get(filters, ["dateFilter"])]}
          setFormValue={handleChange}
          title={"period"}
          id={"period"}
          type="select"
          options={{
            noSort: true,
            options: map(availablePeriods, (p) => ({
              id: p.daysNumber,
              name: I18n.get(`dashboard_${p.name}`),
            })),
          }}
        />
      </Grid>
      {get(filters, ["dateFilter"]) === "custom" && (
        <>
          <Grid item style={{ margin: "0px 24px", maxWidth: "200px" }}>
            <DatePicker
              label={I18n.get("site_startDate")}
              name="startDate"
              value={get(filters, ["startDate"])}
              onChange={handleChangeDate}
              width={200}
            />
          </Grid>
          <Grid item style={{ maxWidth: "200px" }}>
            <DatePicker
              label={I18n.get("site_endDate")}
              name="endDate"
              value={get(filters, ["endDate"])}
              onChange={handleChangeDate}
              width={200}
            />
          </Grid>
        </>
      )}
      <Grid item>
        <CustomButton
          variant="contained"
          color="primary"
          onClick={() => search(filters)}
          style={{ marginLeft: "24px", marginTop: "4px" }}
        >
          {I18n.get("dashboard_search")}
        </CustomButton>
      </Grid>
    </Grid>
  );
};

export default MdcForm;
